module.exports = __webpack_public_path__ + "media/images/search_close-6f5c5245.svg";